import { useEffect, useRef, useState } from "react";
import { getMenuWidth } from "../../../utils/getWindowDimensions";
import MenuItem from "./MenuItem";
import { userTypes } from "../../../data/types/userTypes";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { itemStdWidth, versionsAccess } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { versionsType } from "../../../data/types/versionsType";
import { sectionsList } from "../../../data/sectionsList";
import { useMainContext } from "../../../context/MainContext";

export default function MainBox({
  height,
  cVersion,
}: {
  height: string;
  cVersion: versionsType;
}) {
  const user: userTypes = useSelector((state: RootState) => state.data.user);
  const [itemWidth, setItemWidth] = useState<number>(getMenuWidth());
  const divRef = useRef<HTMLDivElement | null>(null);
  const { setMainMenuHeader } = useMainContext();

  useEffect(() => {
    correctWidth();
    const observer = new ResizeObserver(correctWidth);

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const correctWidth = () => {
    if (divRef.current) {
      let units = Math.trunc(divRef.current.clientWidth / itemStdWidth);
      let tempWidth = divRef.current.clientWidth - (30 + (units - 1) * 15);
      let tempItemWidth = tempWidth / units - 0.5;
      if (itemWidth !== tempWidth) {
        setItemWidth(tempItemWidth);
      }
    }
  };

  return (
    <div ref={divRef} className="screen" style={{ height }}>
      <div className="wrapBox">
        {sectionsList
          .filter(
            (e: stdObject) =>
              (["B", "C"].includes(e.id) && user.VENTAS) ||
              !["B", "C"].includes(e.id),
          )
          .filter(
            (e: stdObject) =>
              versionsAccess[cVersion].includes(e.id) &&
              user[e.id as keyof userTypes] === 1,
          )
          .map((e, index) => (
            <MenuItem
              key={index}
              data={e}
              onClick={() => setMainMenuHeader(e)}
              width={itemWidth}
            />
          ))}
      </div>
    </div>
  );
}
